import { serviceRoot } from "../contexts/BackendProps"

export const serviceFetch = async (url, method, body) => {
    let csrftoken = "";
    if (document.cookie) {
        let splitted = document.cookie.split("; ")
        let aux = splitted.find((row) => row.startsWith("csrftoken="));
        csrftoken = aux.split("=")[1];
    }
    let params = {
        method: method,
        body: body,
        credentials: "include",
        headers: {
            "X-CSRFToken": csrftoken,
            // "SameSite": "Secure"
        },
        mode: "cors"
    };
    return fetch(`${serviceRoot}/${url}`, params);
}

export const serviceHttpRequest = async (url, params, uploaded = null, uploadprogress = null, mimetype="multipart/form-data") => {
    // should use XMLHttpRequest
    return new Promise((resolve, reject) => {
        let csrftoken = "";
        if (document.cookie) {
            let splitted = document.cookie.split("; ")
            let aux = splitted.find((row) => row.startsWith("csrftoken="));
            csrftoken = aux.split("=")[1];
        }

        let xhr = new XMLHttpRequest();
        xhr.open(params.method, `${serviceRoot}/${url}`, true);
        xhr.overrideMimeType(mimetype);
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.withCredentials = true;
        if (uploadprogress) {
            xhr.upload.onprogress = uploadprogress;
        }
        if (uploaded) {
            xhr.upload.onloadend = uploaded;
        }
        xhr.onload = function () {
            if (xhr.status === 200) {
                let response = JSON.parse(xhr.responseText);
                resolve(response);
            } else {
                console.log("Error: " + xhr.status);
                reject(new Error(xhr.responseText));
            }
        };
        xhr.onerror = function () {
            console.log("Error: " + xhr.status);
            reject(new Error(xhr.status));
        };
        xhr.send(params.body);
    });
};